export const siteData = {
  name: "Centro Volantín",
  tagline: "Especialistas en Desarrollo Infantil.",
  description: "Acompañamiento terapéutico integral para niños y familias.",
  
  contact: {
    phone: "+569 40531949",
    whatsapp: "+56912345678",
    email: "centrovolantin@gmail.com",
    address: "Estoril 50, oficina 1108, Las Condes, Santiago de Chile",
    hours: "Lunes a Viernes 8:00 a 20:00 | Sábados 7:00 a 14:00"
  },
  
  social: {
    facebook: "https://facebook.com/centrovolantin",
    instagram: "https://instagram.com/centrovolantin",
    youtube: "https://youtube.com/@centrovolantin"
  },
  
  vision: "Aspiramos a ser un referente líder en la atención integral de la niñez y preadolescencia, reconocidos por nuestra cercanía, la excelencia de nuestro equipo multidisciplinario y nuestra capacidad para construir una comunidad activa y colaborativa que impulse el bienestar y el pleno desarrollo de cada niño y joven.",
  
  mission: "En Centro Volantín, nos dedicamos con calidez y profesionalismo a potenciar el desarrollo integral de la primera infancia y la adolescencia. A través de un equipo multidisciplinario comprometido, creamos un espacio seguro y acogedor que fomenta la conexión, el aprendizaje significativo y la construcción de una comunidad sólida entre niños, jóvenes y sus familias "
};
